"use client";

import { useEffect, useState } from "react";
import { MapContainer, TileLayer, Marker, useMap } from "react-leaflet";
import L from "leaflet";
import { AnimatePresence, motion } from "framer-motion";
import { FaMapMarkerAlt } from "react-icons/fa";
import "leaflet/dist/leaflet.css";
import "leaflet-defaulticon-compatibility/dist/leaflet-defaulticon-compatibility.css";
import "leaflet-defaulticon-compatibility";
import { useGeolocationStore } from "@/store/geolocationStore";

type Props = {
  defaultLat?: number | null;
  className?: string;
  error: any;
  defaultLng?: number | null;
  onChange?: (lat: number, lng: number) => void;
  onlyMap?: boolean;
};

const UpdateMapView = ({ lat, lng }: { lat: number; lng: number }) => {
  const map = useMap();
  useEffect(() => {
    map.setView([lat, lng], 20);
  }, [lat, lng, map]);

  return null;
};

export default function FormMapInput({
  defaultLat = -6.2088,
  defaultLng = 106.8456,
  error,
  onChange,
  className,
  onlyMap = false,
}: Props) {
  const latlng = useGeolocationStore((state) => state.location_data);
  const [position, setPosition] = useState<[number, number] | null>([
    -6.2297209, 106.664705,
  ]);
  const [show, setShow] = useState(onlyMap ? true : false);

  useEffect(() => {
    if (latlng?.value) {
      setPosition([
        (latlng?.value as number[])![0] ?? defaultLat,
        (latlng?.value as number[])![1] ?? defaultLng,
      ]);
      onChange?.(
        (latlng?.value as number[])![0] as number,
        (latlng?.value as number[])![1] as number
      );
    }
  }, [latlng]);

  useEffect(() => {
    if (defaultLng && defaultLat) {
      setPosition([defaultLat, defaultLng]);
    }
  }, [defaultLat, defaultLng]);
  return (
    <div className={`flex flex-col gap-4 ${className ?? ""}`}>
      {!onlyMap && (
        <button
          onClick={() => setShow(!show)}
          type="button"
          className="flex btn btn-sm btn-primary btn-outline btn-block justify-center items-center"
        >
          Tandai Account pada peta <FaMapMarkerAlt />
        </button>
      )}

      {show ? (
        <AnimatePresence>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="h-[300px] relative !z-0 overflow-hidden rounded-lg shadow"
          >
            <div className="absolute m-4 top-0 right-0 bg-white z-[1000] p-4 text-md shadow-lg rounded-lg flex flex-col">
              <span className="font-bold ">Latitude : {position?.[0]}</span>
              <span className="font-bold ">Longitude : {position?.[1]}</span>
            </div>
            <MapContainer
              center={position!}
              zoom={13}
              style={{ height: "100%", width: "100%" }}
            >
              <TileLayer url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png" />

              <Marker
                draggable
                position={position!}
                eventHandlers={{
                  dragend: (e) => {
                    const marker = e.target as L.Marker;
                    const newPos = marker.getLatLng();
                    setPosition([newPos.lat, newPos.lng]);
                    onChange?.(newPos.lat, newPos.lng);
                  },
                }}
              />

              <UpdateMapView lat={position?.[0]!} lng={position?.[1]!} />
            </MapContainer>
          </motion.div>
        </AnimatePresence>
      ) : null}
      <div className="w-full flex flex-col gap-2">
        {error?.latitude! && (
          <span className="text-error text-xs">
            Latitude : {error.latitude?.message}
          </span>
        )}
        {error?.longitude! && (
          <span className="text-error text-xs">
            Longitude : {error.longitude?.message}
          </span>
        )}
      </div>
    </div>
  );
}
